import { DesignSystemPrimitive } from 'designSystem/types';
import { ButtonPrimitivePreview } from './ButtonPrimitivePreview';
import { CardPrimitivePreview } from './CardPrimitivePreview';
import { TypographyPrimitivePreview } from './TypographyPrimitivePreview';
import { LayoutPrimitivePreview } from './LayoutPrimitivePreview';
import { FormPrimitivePreview } from './FormPrimitivePreview';
import { GenericPrimitivePreview } from './GenericPrimitivePreview';
import * as S from './styles';

interface PrimitiveCardProps {
	primitive: DesignSystemPrimitive;
	selected?: boolean;
	onClick?: () => void;
}

export const PrimitiveCard = ({ primitive, selected, onClick }: PrimitiveCardProps) => {
	const renderPreview = () => {
		switch (primitive.category) {
			case 'button':
				return <ButtonPrimitivePreview primitive={primitive} />;
			case 'card':
				return <CardPrimitivePreview primitive={primitive} />;
			case 'typography':
				return <TypographyPrimitivePreview primitive={primitive} />;
			case 'layout':
				return <LayoutPrimitivePreview primitive={primitive} />;
			case 'form':
				return <FormPrimitivePreview primitive={primitive} />;
			case 'navigation':
			case 'other':
			default:
				return <GenericPrimitivePreview primitive={primitive} />;
		}
	};

	return (
		<S.PrimitiveCard selected={selected} onClick={onClick}>
			{renderPreview()}
			<S.PrimitiveName>{primitive.baseSelector}</S.PrimitiveName>
		</S.PrimitiveCard>
	);
};
